import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortV2Component } from './sort-v2.component';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [SortV2Component],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    ButtonModule
  ],
  exports: [SortV2Component]
})
export class SortV2Module { }
